import React from 'react';
import './index.css';
import util from "../../util/tools";
import LoadMore from '../common/LoadMore'
import Header from "../common/Header";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            data:[],
            isLoad:false,
        };

        this.getDataFun = this.getDataFun.bind(this);
        this.editFun = this.editFun.bind(this);
    }

    componentDidMount() {
        document.title = '查看物流信息';
        this.getDataFun();
    }

    getDataFun(){
        let num = 20;
        util.ajax({
            // host: "http://open.fangkuai8.com",
            url: "/zh/sendgift/lists",
            // app_key: "6821674987",
            // app_secret: "55f3b0e685b97de7e9c47ab3cd940vdn",
            isUser: true,
            isWechatId: true,
            data: {
                '__flush_cache': 1,
                'num':num,
                'page':this.state.page
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempObj = {
                        page: this.state.page+1,
                        data: this.state.data.concat(json),
                        isLoad: json.length >= num
                    };

                    this.setState(tempObj)
                }
            }
        });
    }

    editFun(status,gift_id,draw_record_id){
        console.log(status);
        // if(!!draw_record_id){
        //     // 抽奖大礼包
        //     this.props.history.push(`cj1/${gift_id}`)
        //     return false;
        // }
        if(status != 1){
            return false;
        }
        this.props.history.push(`/wuliuinfo/${gift_id}`)
    }

    render() {
        return (
            <div className='wuliupage'>
                <Header />
                <div className='list'>
                    {
                        !!this.state.data && this.state.data.length>0 &&
                        this.state.data.map((item,index) => {
                            return (
                                <div className={`item status${item.status}`} key={`list_${index}`} onClick={()=>this.editFun(item.status,item.gift_id,item.draw_record_id)}>
                                    <div className={`userBox`}>
                                        <div className={`userName text-overflow`}>{item.user_name}<span className="phonetxt">{item.phone}</span></div>
                                        <div className='address text-overflow'>{item.province}{item.city}{item.county}{item.address}</div>
                                    </div>
                                    <div className='orderBox'>
                                        <div className='orderNo text-overflow'>订单号:{item.order_no}({item.gift_type==2?"抽奖":parseInt(item.fee/100)}大礼包)</div>
                                        <div className='clearfix'>
                                            <div className='txt text-overflow'>快递公司:{item.tracking_company}</div>
                                            <div className='txt text-overflow'>物流编号:{item.tracking_no}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {
                    !(!!this.state.data && this.state.data.length>0) &&
                    <div className={'tips'}>
                        <p>亲爱的用户</p>
                        <p>您暂无物流信息哦～</p>
                    </div>
                }
                {this.state.isLoad && <LoadMore loadMoreData={()=>this.getDataFun()}/>}
            </div>
        );
    }
}